import { Link } from "react-router-dom";
import { useState } from "react";
import "./LoginV4.css";

export default function LoginV4(): JSX.Element {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <div className="pp-page lvg4">
      <Link to="/" className="lvg4-brand">
        <span className="lvg4-brand-glyph"></span> SubsWall
      </Link>

      <div className="lvg4-shell">
        <div className="lvg4-card">
          {!sent ? (
            <>
              <div className="pp-eyebrow">Claim your wall</div>
              <h1 className="pp-display lvg4-h1">Welcome.</h1>
              <p className="pp-lead lvg4-lead">
                We'll send you a one-time sign-in link. No passwords.
              </p>

              <form onSubmit={(e) => { e.preventDefault(); if (email) setSent(true); }}>
                <label className="lvg4-field">
                  <span className="pp-eyebrow">Email</span>
                  <input
                    type="email"
                    autoFocus
                    placeholder="you@channel.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                <button type="submit" className="pp-btn pp-btn-primary lvg4-cta">
                  Send sign-in link →
                </button>
              </form>

              <div className="lvg4-divider"><span>or</span></div>

              <button className="pp-btn pp-btn-ghost lvg4-oauth" disabled>
                <span>▶</span> Continue with YouTube
              </button>
              <button className="pp-btn pp-btn-ghost lvg4-oauth" disabled>
                <span>◆</span> Continue with Twitch
              </button>

              <div className="lvg4-foot">
                By signing in you agree to our <Link to="/terms">Terms</Link>{" "}
                and <Link to="/privacy">Privacy</Link>.
              </div>
            </>
          ) : (
            <>
              <div className="pp-eyebrow">Check your inbox</div>
              <h1 className="pp-display lvg4-h1">Sent to {email}.</h1>
              <p className="pp-lead lvg4-lead">
                Click the link we just sent to finish signing in.{" "}
                <button type="button" onClick={() => setSent(false)} className="lvg4-resend">
                  Try a different email
                </button>.
              </p>
            </>
          )}
        </div>
        <Link to="/" className="lvg4-back">← Back to home</Link>
      </div>
    </div>
  );
}
